var angular = require('angular');

var loggerService = require('./services/loggerService');
var textBundleService = require('./services/textBundleService');
var userSessionStore = require('./services/userSessionStore');

var core = angular.module('core', [loggerService, textBundleService, userSessionStore]);

module.exports = core.name